<template>
  <el-row :style="rowStyle">
    <el-col :span="10" class="__col-h100">
      <div class="__panel __tree-panel">
        <div class="__panel-heading"><span v-html="$lang(flowName)"></span></div>
        <div class="__panel-body">
          <template>
          <mw-level-tree :ref="'candidate'+flowId" :key="flowId" :type="flowType"
                            :url="url" :appendRefresh="appendRefresh" :defaultParams="defaultParams"
                            :businessId='params.businessId' :activityId="activityId" @beforeDataFilter="treeDataFilter"
                            :async="true" :autoLoad="true" :multiple="true" :expandedFirst="true" :flowCount="1" v-show="true" v-if="true">
          </mw-level-tree>
          </template>
      </div>
      </div>
    </el-col>
    <el-col :span="2" class="__col-h100">
      <div class="__sel">
        <el-button type="primary" class="__btn" :leading="sendBtnLeading" @click="sendClick()" style="padding-bottom:5px;">{{$lang("发送")}}>></el-button>
        <br/><br/>
        <el-button  class="__btn" :leading="takenBtnLeading" @click="takenClick()" style="padding-top:5px;"><<{{$lang("取回")}}</el-button>
      </div>
    </el-col>
    <el-col :span="6" class="__col-h100">
      <div class="__panel __tree-panel">
        <div class="__panel-heading">{{$lang("在办")}}</div>
        <div class="__panel-body">
          <mw-li-tree :ref="'doing'+flowId" :autoLoad="true" :async="false" :multiple="true"
                       :treeData="doings" ></mw-li-tree>
        </div>
      </div>
    </el-col>
    <el-col :span="6" class="__col-h100" style="padding-left:5px;">
      <div class="__panel __tree-panel">
        <div class="__panel-heading">{{$lang("办毕")}}</div>
        <div class="__panel-body">
          <li class="__item"  v-for="n in finisheds" v-html="n.name"></li>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
  import MwLevelTree from "../tree/level.vue";
  import MwLiTree from "../tree/li.vue";
  export default {
    name:'MwWtTree',
    components: {
      MwLevelTree,
      MwLiTree
    },
    props: {
      params: { //businessId、taskId、formId、appId
        type: Object
      },
      rowStyle:{
        type:String,
        default:function(){
            return 'height:225px; padding-top:5px;';
        }
      },
      flowId:{
        type: String
      },
      flowName:{
        type: String
      },
      flowType:{
          type:String
      },
      options:{
        type: Object
      },
      activityId:{
        type: String
      },
      //加载数据地址
      url: {
        type: String
      },
      appendRefresh:{
        type: Boolean,
        default: false
      },
      doings:{
        type:Array,
        default:function(){
            return [];
        }
      },
      finisheds:{
        type:Array,
        default:function(){
          return [];
        }
      }
    },
    data() {
      let me=this;
      return {
        defaultParams:{},
        sendBtnLeading:false,
        takenBtnLeading:false,
        isOperation : false
      }
    },
    methods: {
      btnDebounce:_.debounce(function(callback){
        let me=this;
        if(callback){
          callback();
        }
      }, 1000, {
        'leading': true,
        'trailing': false
      }),
      treeDataFilter(data){
        var me = this;
        var doIds=[];
        me.doings.map((d, idx)=>{
          doIds.push(d.id);
        });
        data.forEach(d=>{
          if(doIds.indexOf(d.id) !=-1){
            d.hidden = true;
          }
          if(!d.text) {
            if (d.name) {
              d.text = d.name;
              if (window.$currentBrowserLanguage==='en') d.text = d.Englishname || d.name;
            }
          }
          d.originalId=d.id; //原ID赋值给originalId
          if(d.type && d.type=='U'){ //节点是用户 存在不唯一的情况
            if(d.parentId){
              d.id=d.parentId+"_"+d.id; //新ID：部门ID_用户ID
            }
          }
          if(d.children && d.children.length>0){
            me.treeDataFilter(d.children);
          }else{
            if(d.hasReal==undefined){
              d.children=false;
              d.type='file';
            }else{
              d.children=d.hasReal;
              if(!d.hasReal){
                d.type='file';
              }else{
                d.type='default';
              }
            }
            /*if(d.hasChild==undefined || d.hasChild< 1){
              d.children=false;
              d.type='file';
            }else{
              d.children=true;
              d.type='default';
            }*/
          }
        });
      },
      sendClick(){ //选中已选发送
        var me = this;
        me.btnDebounce(function(){
          me.sendBtnLeading=true;
          var data = me.mwRef('candidate'+me.flowId).getSelectNodes();
          if(data.length< 1){
            me.sendBtnLeading=false;
            return;
          }
          var activities = [];
          var activity={};
          activity.items=me._nodeAsItems(data);
          activity.flowId=me.flowId;
          activity.activityId=me.activityId;
          activity.type = me.flowType;
          activity.options=me.options;
          activities.push(activity);
          var params={};
          params.taskId=me.params.taskId;
          params.appId=me.params.appId;
          params.formId = me.params.formId;params.formKey = me.params.formKey;
          params.type="complete";
          params.actionDescription="发送";
          params.activities=activities;
          me.params.isOperation = true;
          if(me.params.fullAuthType){
            params.fullAuthType = me.params.fullAuthType;
          }
          me.mwApi.process.batchCommit(params).then((res)=>{
            var rr = res.result;
            if(rr && typeof res.success !='undefined' && !rr.success){
              me.mwMsg('info', '发送失败!');
              me.sendBtnLeading=false;
              return;
            }else if(res.success){
              data.map((v)=>{
                //移入在办框
                me.doings.push(v);
                //移出办毕框
                var fidx;
                me.finisheds.map((fv, d)=>{
                  if(fv.id==v.id){
                    fidx=d;
                    return;
                  }
                });
                me.finisheds.splice(fidx, 1);
              });
              //刷新在办框
              me.mwRef('doing'+me.flowId).refreshData(me.doings);
              ////移出备选办框
              data.map((v)=>{
                me.mwRef('candidate'+me.flowId).hideNode(v.id);
              });
              me.sendBtnLeading=false;
            }
          }).catch(()=>{
            me.sendBtnLeading=false;
          })
        });
      },
      takenClick(){//选中在办取回
        var me = this;
        me.btnDebounce(function(){
          me.takenBtnLeading=true;
          var data = me.mwRef('doing'+me.flowId).getSelectNodes();
          if(data.length< 1){
            me.takenBtnLeading=false;
            return;
          }
          var masterObjectIds = [];
          data.map((v)=>{
            masterObjectIds.push(v.id);
          });
          var params = {};
          params.taskId = me.params.taskId;
          params.flowId = me.flowId;
          params.masterObjectIds = masterObjectIds;
          if(me.params.fullAuthType){
            params.fullAuthType = me.params.fullAuthType;
          }
          if(window.$Env && $Env.yzTakenFilterSecondSend){
            params.filterSecondSend = true;
          }
          me.params.isOperation = true;
          me.mwApi.process.batchTakenSubProcess(params).then((res)=>{
            if(res.success){
              var sent = res.result && res.result.sent && res.result.sent.length ? res.result.sent : [];
              if(sent.length > 0){
                PF.message("["+sent.join(",")+"]已办理，不能取回");
              }
              data.map((v)=>{
                //移出在办框
                if(sent.indexOf(v.name)==-1) {
                  var idx;
                  me.doings.map((fv, d) => {
                    if (fv.id == v.id) {
                      idx = d;
                      return;
                    }
                  });
                  me.doings.splice(idx, 1);
                }
              });
              //刷新备选框
              data.map((v)=>{
                var nodeId;
                if(v.departmentId){
                  nodeId=v.departmentId+"_"+v.id;
                }else{
                  nodeId = v.id;
                }
                me.mwRef('candidate'+me.flowId).showNode(nodeId);
              });
              //刷新在办框
              me.mwRef('doing'+me.flowId).refreshData(me.doings);
            }
            me.takenBtnLeading=false;
          }).catch(()=>{
            me.takenBtnLeading=false;
          });
        });
      },
      _nodeAsItems(data){
        var me = this;
        var items=[];
        var ids = [];
        var options=me.options;
        if(options && options.activityUnit=='group'){//办理单位为部门
          data.map(d=> {
            if(ids.indexOf(d.id) == -1) { //排除重复,例如：同一个用户不同部门
              ids.push(d.id);
              if (d.identities && d.identities.length > 0) {//选择单位为部门或部门树、合并到上级
                var item = {};
                item.group = d.id;
                d.identities.map(i => {
                  if (i.type == 'U') {
                    if (!item.users) {
                      item.users = [];
                    }
                    if (i.id.indexOf("_") > -1) {
                      item.users.push({id: i.id.split("_")[1]});
                    } else {
                      item.users.push({id: i.id});
                    }
                  } else {
                    if (!item.identities) {
                      item.identities = [];
                    }
                    item.identities.push({id: i.id});
                  }
                });
                items.push(item);
              } else {
                var item = undefined;
                items.map(i => {
                  if (i.group == d.parentId) {
                    item = i;
                  }
                })
                if (item) {
                  if (d.id.indexOf("_") > -1) {
                    item.users = [{id: d.id.split("_")[1]}];
                  } else {
                    item.users = [{id: d.id}];
                  }
                } else {
                  item = {};
                  item.group = d.parentId;
                  if (d.id.indexOf("_") > -1) {
                    item.users = [{id: d.id.split("_")[1]}];
                  } else {
                    item.users = [{id: d.id}];
                  }
                  items.push(item);
                }
              }
            }
          });
          return items;
        }
        //办理单位为用户
        data.map(d=>{
          if(ids.indexOf(d.id) == -1) { //排除重复,例如：同一个用户不同部门
            ids.push(d.id);
            var item = {};
            if (d.identities && d.identities.length > 0) { //选择单位为部门或部门树、合并到上级
              item.group = d.id;
              d.identities.map(i => {
                if (i.type == 'U') {
                  if (!item.users) {
                    item.users = [];
                  }
                  if (i.id.indexOf("_") > -1) {
                    item.users.push({id: i.id.split("_")[1]});
                  } else {
                    item.users.push({id: i.id});
                  }
                } else {
                  if (!item.identities) {
                    item.identities = [];
                  }
                  item.identities.push({id: i.id});
                }
              });
            } else {
              item.group = d.parentId;
              if (d.id.indexOf("_") > -1) {
                item.users = [{id: d.id.split("_")[1]}];
              } else {
                item.users = [{id: d.id}];
              }
            }
            items.push(item);
          }
        });
        return items;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/common/components/public-dialog/worktrack/treewt.vue